import {jsx} from 'panel';
import {VNode} from 'snabbdom';

import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';
import {InputEl} from 'common/components/input';
import {InputTheme} from 'common/components/input/types';

/**
 * Search bar for a child menu
 */
export function MenuSearchBar({
  value,
  handleSearchInput,
  backButtonClick,
  suffixRenderer,
  placeholder = `Search...`,
  onInsert,
  key = null,
  newStyling = false,
}: {
  value: string;
  handleSearchInput: (value: string) => void;
  backButtonClick?: () => void;
  suffixRenderer?: VNode;
  placeholder?: string;
  onInsert?: (ev: HTMLElement) => void;
  key?: string;
  newStyling?: boolean;
}) {
  return (
    <div sel='.search-wrapper' key={key}>
      {backButtonClick && (
        <ButtonEl
          attrs={{
            icon: `arrow-left`,
            theme: ButtonTheme.Tertiary,
            role: `button`,
            tabindex: 0,
          }}
          on={{
            click: backButtonClick,
          }}
        />
      )}
      <InputEl
        attrs={{
          'auto-focus': true,
          placeholder,
          icon: ``,
          'show-clear': true,
          elref: `searchInput`,
          theme: newStyling ? InputTheme.New : InputTheme.Default,
        }}
        props={{value}}
        on={{
          input: (ev) => handleSearchInput(ev.target.value),
          clear: () => handleSearchInput(``),
        }}
        hook={{
          insert:
            onInsert &&
            ((vnode) => {
              const el = vnode.elm as HTMLElement;
              onInsert(el);
              el.focus();
            }),
        }}
      />

      {/* displays arbitrary content the the side of the search bar */}
      {suffixRenderer}
    </div>
  );
}
